<div class="p-6 flex flex-col gap-6 bg-lGray900 rounded-[24px]">

  <div class="flex items-start justify-between">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-bold text-color">Convidar usuário</h2>
      <p class="text-sm subtext-color">Envie um convite por e-mail para acessar a plataforma</p>
    </div>
    <button (click)="close()" class="text-lGray500 hover:text-lGray300 transition-colors p-1">
      <l-icon class="text-2xl">close</l-icon>
    </button>
  </div>

  <div class="flex justify-center">
    <img
      src="assets/icons/mail.svg"
      alt="Convidar usuário"
      class="h-44 w-auto object-contain"
    />
  </div>

  <form [formGroup]="formGroup" class="flex flex-col gap-4" (ngSubmit)="submit()">
    <div class="flex flex-col gap-1">
      <label for="invite-user-email" class="text-sm font-medium text-color">
        E-mail <span class="text-lDanger">*</span>
      </label>
      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 subtext-color text-xl">mail</l-icon>
        <input
          id="invite-user-email"
          lInput
          formControlName="email"
          type="email"
          placeholder="Digite o e-mail"
          class="pl-11 border-none rounded-xl"
          [ngClass]="{ '!border-lDanger': emailControl.invalid && emailControl.touched }"
        />
      </div>
      @if (emailControl.touched) {
        @if (emailControl.hasError('required')) {
          <small class="text-lDanger text-xs">E-mail é obrigatório</small>
        } @else if (emailControl.hasError('email')) {
          <small class="text-lDanger text-xs">E-mail inválido</small>
        }
      }
    </div>

    <p class="text-xs text-lDanger">(*) Campos obrigatórios</p>
  </form>
</div>

<div class="flex justify-center mt-10">
  <button
    lButton
    [bType]="isSubmitting || formGroup.invalid ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
    [bSize]="buttonSizeEnum.MEDIUM"
    [bRadius]="buttonRadiusEnum.LARGE"
    [disabled]="formGroup.invalid || isSubmitting"
    (click)="submit()"
  >
    @if (isSubmitting) {
      <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
    }

    Enviar convite
  </button>
</div>